import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { AnnouncementOutlined, Edit, FileCopy } from '@material-ui/icons';

import { primary, successColor } from 'core/ui/Colors';
import { dateExt } from 'core/utils/formatters';

export default function ItemRow({ channel, item, onEditClick }) {
  const [open, setOpen] = React.useState(false);

  const showPrevText = () => {
    const text = item.text || '';
    if (text.length > 50) {
      return `${item.text.substring(0, 50)}...`;
    }
    return text;
  };

  return (
    <>
      <TableRow className="hover" onClick={() => setOpen(!open)}>
        <TableCell style={{ width: 50 }}>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">
          <AnnouncementOutlined style={{ color: item.showing ? successColor : primary }} />
        </TableCell>
        <TableCell>{showPrevText()}</TableCell>
        <TableCell align="center">
          {dateExt(item.startAt, null, channel?.dateFormatExtReact)}
        </TableCell>
        <TableCell align="center">
          {dateExt(item.endAt, null, channel?.dateFormatExtReact)}
        </TableCell>
        <TableCell align="right">
          <Box display="flex" alignItems="center">
            <IconButton onClick={() => onEditClick({ ...item, id: null })}>
              <FileCopy />
            </IconButton>
            <IconButton onClick={() => onEditClick(item)}>
              <Edit />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box m={5} display="flex" justifyContent="center">
              {item.text}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

ItemRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
  onEditClick: PropTypes.func.isRequired,
};
